"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("../module/ModuleRegistryFactory"));
class ImageSrcWithVersion {
    static getImage(imageSrc) {
        if (!ImageSrcWithVersion.bootVersion) {
            const bootApplicationRegistry = ModuleRegistryFactory_1.default.getBootApplicationRegistry();
            // @ts-ignore
            const localModules = bootApplicationRegistry?.getLocalModules?.();
            const infoModule = localModules?.find(module => module.getName() === "info");
            if (infoModule) {
                const bootModuleVersion = infoModule.getVersion?.();
                if (bootModuleVersion) {
                    ImageSrcWithVersion.bootVersion = bootModuleVersion.getPomVersion();
                }
            }
        }
        if (ImageSrcWithVersion.bootVersion) {
            return `${imageSrc}?v=${ImageSrcWithVersion.bootVersion}`;
        }
        return imageSrc;
    }
}
ImageSrcWithVersion.bootVersion = undefined;
exports.default = ImageSrcWithVersion;
//# sourceMappingURL=ImageSrcWithVersion.js.map